export default __webpack_public_path__ + "static/media/ready.1d0365a2.png";